import api from './api'

export const capstoneHintService = {
  // Get all hints for a capstone
  getHints: async (capstoneId) => {
    const response = await api.get(`/capstones/${capstoneId}/hints`)
    return response.data
  },

  // Unlock a hint
  unlockHint: async (hintId) => {
    const response = await api.post(`/hints/${hintId}/unlock`)
    return response.data
  },
}
